import { BaseContainerModel } from '../../base-container.model';
import { bl_mkp_mst_item_attribute_set_link_RowClass } from '../../../dbschema/bl_mkp_mst_item_attribute_set_link.model';

export class MkpItemAttributeSetLinkContainerModel extends BaseContainerModel {
  bl_mkp_mst_item_attribute_set_link: bl_mkp_mst_item_attribute_set_link_RowClass = new bl_mkp_mst_item_attribute_set_link_RowClass();
}